import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Typeahead} from 'react-bootstrap-typeahead';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');
var report = require('../../generics/report_head');

class UserTraceability extends Component{
	constructor(props){
		super(props);

		this.setTable = this.setTable.bind(this);
		this.searching = this.searching.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.prevent = this.prevent.bind(this);
		this.showDetails = this.showDetails.bind(this);

		this.state = {
			filename: 'Trazabilidad Usuario',
			columns: [
				{title:'details', visible:false},
				{title:'Fecha Hora'},
				{title:'Unidad'},
				{title:'Acción'},
				{title:'IP'}
			],
			listado:[],
			donation_number:"",
			component:{},
			components:[],
			details:false,

			start_date:"",
			end_date:"",
			user_id:"",
			users:[],
			user_selected:[],
			index_user:-1,
			load_user:false,
			date_hour:"",
			medical:"",

		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		fetch(Config.default.apiGateway.URL+'users/medical_staff', {
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({users:response.res});
			}
		})

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		})

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		this.setState({
			[e.target.id]: e.target.value,
		});

		if(e.target.value !== ""){
			document.getElementById(e.target.id).classList.remove('error');
		}
	}

	searching(e){
		e.preventDefault()
			
		if(this.state.start_date !== "" && this.state.end_date !== "" && this.state.user_id !== ""){
			document.getElementById('start_date').classList.remove('error');
			document.getElementById('end_date').classList.remove('error');
			document.getElementById('user_id').classList.remove('error');
			
			this.props.waiting.handleShow('Cargando...');
			fetch(Config.default.apiGateway.URL+'traceabilities/by_user?user_id='+this.state.user_id+
				'&start_date='+this.state.start_date+'&end_date='+this.state.end_date,{
				method:'GET',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					var list = [];
					response.res.map((r)=>{
						list.push([
							r.flag_details,
							moment(r.timestamp).format('DD/MM/YYYY HH:mm'),
							r.unit_number !== null && r.unit_number !== undefined? r.unit_number : '',
							r.description,
							r.ip
						])
					})

					this.setState({
						listado: list
					});

					setTimeout(()=>{
						this.props.waiting.handleShow('Cargando...');
						this.$el = $(this.el);
						this.$el.DataTable().destroy();
						this.$el.empty();
					}, 500);

					setTimeout(()=>{
						this.props.waiting.handleClose();
						this.setTable();
					}, 1000);
						
					this.props.waiting.handleClose();
				}
			});
		}else{
			swal('Error', 'Campos Incompletos', 'error');
			if(this.state.start_date === ""){
				document.getElementById('start_date').classList.add('error');
			}
			if(this.state.end_date === ""){
				document.getElementById('end_date').classList.add('error');
			}
			if(this.state.user_id === ""){
				document.getElementById('user_id').classList.add('error');
			}
			
		}
	}

	setTable(){
		this.$el = $(this.el);
		
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	exportOptions:{
					    columns: ':visible'
					},
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});

						doc.content.splice(2, 0, {text: 'Fecha de emisión '+this.state.date_hour, margin:[10,0,0,10] });

						doc.content[3].table.widths=["12%","12%","64%","12%"];
						doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            	],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sLoadingRecords":"Cargando...",
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
			createdRow: (row, data, dataIndex)=>{
				if(data[0] !== false && !this.state.details){
					$(row).css('display', 'none');
				}else{
					$(row).removeAttr('style');
				}
            }

		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	prevent(e){
		if(e.key === 'Enter'){
			e.preventDefault();
		}
	}

	showDetails(e){
		this.setState({
			details: e.target.checked ? true : false
		})

		setTimeout(()=>{
			this.props.waiting.handleShow('Cargando...');
			this.$el = $(this.el);
			this.$el.DataTable().destroy();
			this.$el.empty();
		}, 500);

		setTimeout(()=>{
			this.props.waiting.handleClose();
			this.setTable();
		}, 1000);

	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	
    		this.setState({load_user:true});

    		setTimeout(()=>{
    			this.setState({
					index_user:0,
					user_selected:values,
					load_user:false,
					user_id:values[0].id,
			    });

			    this._typeahead_user.getInstance().blur();
			    //document.getElementById('plasmatic_product_amount').focus();

    		}, 1000);
	        		
        	
	    		        	
        }
    }

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.warehouse.MAIN')} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Trazabilidad de Usuario
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_storage"} 
		            submenu={"help_user_traceability"}  />
		            
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<fieldset>
								<legend style={{fontSize:"1.5em", marginBottom:"5px"}}>Búsqueda</legend>
								<div className="col-xs-12 form-group">
									<div className="col-xs-12 col-sm-2">
										<span className="span-min">Fecha Desde</span>
										<input className="form-control" type="date" name="start_date" 
											id="start_date" onChange={this.handleChange} 
											value={this.state.start_date || ""} 
											autoFocus={true} />
									</div>
									<div className="col-xs-12 col-sm-2">
										<span className="span-min">Fecha Hasta</span>
										<input className="form-control" type="date" name="end_date" 
											id="end_date" onChange={this.handleChange} 
											value={this.state.end_date || ""}  />
									</div>

									<div className="col-xs-12 col-sm-3">
										<span className="span-min">Usuario</span>
										{/*<select className="form-control" name="user_id" id="user_id"
											value={this.state.user_id} onChange={this.handleChange}>
											<option value="">Seleccione...</option>
											{this.state.users.map((u, i)=>(
												<option key={i} value={u.id}>
													{u.medical_staff}
												</option>
											))}
										</select>*/}
										<Typeahead
								          	labelKey={(option) => `${option.medical_staff}`}
								          	minLength={0}
								          	maxLength={50}
								          	inputProps={{
							          			name:"user_id",
							          			id:"user_id",
							          	  	}}
							          	  	id="auto_user"
								          	options={this.state.users}
								          	onChange={this.handleTypeAheadChange('user')}
								          	ref={ref => this._typeahead_user = ref}
								          	isLoading={this.state.load_user}
								          	selectHintOnEnter={true}
								          	delay={600}
								          	paginationText="Mostrar mas resultados..."
								        />
									</div>
									{/*}
									<div className="col-xs-12 reservedHour">
										<span className="span-min">No. Componente</span>
										<Typeahead
								          	labelKey={(option) => `${option.label}`}
								          	minLength={0}
								          	maxLength={50}
								          	inputProps={{
							          			name:"code_component",
							          			required:'required'
							          	  	}}
							          	  	id="code_component"
								          	options={this.state.components}
								          	onChange={this.loadComponent}
								          	ref={ref => this._typeahead = ref}
								          	isLoading={this.state.isLoading}
								          	selectHintOnEnter={true}
								        />
									</div>*/}
									
									<div className="col-xs-12 col-sm-1"style={{paddingTop:"17px"}}>
					        			<button style={{fontSize:"1em"}} className="btn btn-info" 
					        				type="button" onClick={this.searching} >
					        				{t('content.generics.buttons.search')}
					        			</button>
									</div>
								</div>						
							</fieldset>	
						</form>
					</div>

					<div className="col-xs-12">
						<input type="checkbox" checked={this.state.details} onClick={this.showDetails} style={{marginRight:'5px'}} />
						<span>Detalles</span>
					</div>
					
					<div className="col-xs-12" id="table-to-pdf">									
						<div className="table-responsive">
							<table style={{fontSize:"11px"}} className={"table"} id="table-to-xls" 
								width="100%" ref={el => this.el = el}>
							</table>
						</div>

					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations')(UserTraceability);